<template>
<b-navbar toggleable="md" type="dark" variant="primary">
  <b-navbar-toggle target="nav_collapse"></b-navbar-toggle>
  <b-navbar-brand href="#">Забота365</b-navbar-brand>
  <b-collapse is-nav id="nav_collapse">
    <b-navbar-nav>
      <b-nav-item-dropdown text="Отчеты Ленинградская Обл" left>

          <b-dropdown-item href="#">Ленинградская Обл</b-dropdown-item>

      </b-nav-item-dropdown>
    </b-navbar-nav>
    <!-- Right aligned nav items -->
    <b-navbar-nav class="ml-auto">
      <b-nav-item href="#" right>Выйти</b-nav-item>
    </b-navbar-nav>
  </b-collapse>
</b-navbar>
</template>
<script>
export default {
  name: 'NavBar'
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/NavBar.vue